export const TEMPORARY_ACCOUNT_NUMBER_LENGTH = 36;
export const GIFTCARD_ITEMID = '99991';
